
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5099_471)"}},[_c('path',{attrs:{"d":"M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z","fill":"#3464BD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.81465 9.42365H12.9715V10.9962C13.4263 10.0918 14.5925 9.27915 16.3444 9.27915C19.7027 9.27915 20.5 11.0795 20.5 14.3826V20.5H17.1V15.1348C17.1 13.2537 16.6453 12.193 15.4876 12.193C13.8819 12.193 13.2147 13.3362 13.2147 15.134V20.5H9.81465V9.42365ZM3.9845 20.3555H7.3845V9.27915H3.9845V20.3555ZM7.87155 5.6675C7.87168 5.95248 7.81516 6.23465 7.70528 6.4976C7.5954 6.76055 7.43435 6.99904 7.2315 7.1992C6.82044 7.60773 6.26404 7.83641 5.6845 7.835C5.10598 7.83461 4.55086 7.60652 4.1392 7.20005C3.93708 6.99921 3.77658 6.76045 3.66689 6.49747C3.55721 6.23448 3.50049 5.95244 3.5 5.6675C3.5 5.09205 3.7295 4.54125 4.14005 4.13495C4.55135 3.72793 5.1067 3.49975 5.68535 3.5C6.26505 3.5 6.82095 3.72865 7.2315 4.13495C7.6412 4.54125 7.87155 5.09205 7.87155 5.6675Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5099_471"}},[_c('path',{attrs:{"d":"M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z","fill":"white"}})])])])
          )
        }
      }
    